import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { api } from '../../context/AuthContext';
import { Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export function NewsletterSection() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/newsletter/subscribe', { email });
      setSubscribeStatus('success');
      setEmail('');
    } catch (error) {
      setSubscribeStatus('error');
    }
  };

  return (
    <section className="py-24 bg-[#09090B]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <Mail className="w-12 h-12 text-[#007AFF] mx-auto mb-6" />
        <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
          {t('landing.newsletterTitle')}
        </h2>
        <p className="text-[#A1A1AA] mb-8">
          {t('landing.newsletterDesc')}
        </p>
        
        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-dark flex-1"
            required
            data-testid="newsletter-email-input"
          />
          <Button type="submit" className="btn-primary" data-testid="newsletter-subscribe-btn">
            {t('landing.subscribe')}
          </Button>
        </form>
        
        {subscribeStatus === 'success' && (
          <p className="text-[#00FF66] mt-4">{t('landing.subscribed')}</p>
        )}
        {subscribeStatus === 'error' && (
          <p className="text-[#FF3333] mt-4">{t('landing.subscribeFailed')}</p>
        )}
      </div>
    </section>
  );
}
